// @flow
import React, { Component } from 'react';
import { SidebarItemLink, SidebarIcon } from './SidebarStyles';
import { withRouter } from 'react-router-dom';

type Props = {
  to: string,
  icon: string,
  label: string,
  exact?: boolean,
  baseRoute: string,
  location: Location,
  excludeRoute?: string
};

class SidebarItem extends Component<Props> {
  render() {
    const excluded = this.props.excludeRoute
      ? Boolean(this.props.location.pathname.includes(this.props.excludeRoute))
      : false;
    const isActive =
      (this.props.location.pathname.includes(this.props.baseRoute) &&
        !excluded) ||
      (this.props.baseRoute === 'dashboard' &&
        this.props.location.pathname === '/');
    return (
      <SidebarItemLink
        to={this.props.to}
        exact={this.props.exact}
        active={isActive}
      >
        <SidebarIcon name={this.props.icon} />
        <h5>{this.props.label}</h5>
      </SidebarItemLink>
    );
  }
}

export default withRouter(SidebarItem);
